import { render, staticRenderFns } from "./KYCRequestList.vue?vue&type=template&id=40fa4b8e&scoped=true"
import script from "./KYCRequestList.vue?vue&type=script&lang=js"
export * from "./KYCRequestList.vue?vue&type=script&lang=js"
import style0 from "./KYCRequestList.vue?vue&type=style&index=0&id=40fa4b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa4b8e",
  null
  
)

export default component.exports